import React, { Fragment, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null }) => {
    const menuRef = useRef(null);
    const {
        innerWidth
    } = useSelector((state) => state.browserSize);

    const toggleMenu = (e) => {
        e.preventDefault();
        const languageSelector = document.getElementById("language-selector");
        if (menuRef.current.classList.contains("navbar__menu--show")) {
            menuRef.current.classList.remove("navbar__menu--show");
            menuRef.current.classList.add("navbar__menu--hide");
        } else {
            menuRef.current.classList.add("navbar__menu--show");
            menuRef.current.classList.remove("navbar__menu--hide");
        }
        const overlay = document.getElementById("overlay");
        if (overlay) {
            if (!contentLink) {
                if (overlay.style.display === "block") {
                    overlay.style.display = "none";
                    if (languageSelector) {
                        languageSelector.classList.add("language-selector-mobile--hide");
                        setTimeout(() => {
                            languageSelector.classList.remove("language-selector-mobile");
                        }, 500);
                    }
                } else {
                    overlay.style.display = "block";
                    if (languageSelector) {
                        languageSelector.classList.add("language-selector-mobile");
                        languageSelector.classList.remove("language-selector-mobile--hide");
                    }
                }
            }
            overlay.addEventListener("click", (event) => {
                toggleMenu(event);
            })
        }
    };
    const toggleMenuLevelThree = (e) => {
        e.preventDefault();
        if (e.target.classList.contains("rotatePlus90deg")) {
            e.target.classList.remove("rotatePlus90deg");
            e.target.classList.add("rotateMinus90deg");
            let menuItem = e.target.nextSibling;
            while (menuItem && menuItem.nodeType != 1 && !menuItem.classList.contains("navbar__menu-1")) {
                menuItem = menuItem.nextSibling;
            }
            menuItem.classList.remove("navbar__menu--relative")
            menuItem.parentElement.style.removeProperty("height");
            menuItem.parentElement.style.removeProperty("position");
        } else {
            e.target.classList.add("rotatePlus90deg");
            e.target.classList.remove("rotateMinus90deg");
            let menuItem = e.target.nextSibling;
            while (menuItem && menuItem.nodeType != 1 && !menuItem.classList.contains("navbar__menu-1")) {
                menuItem = menuItem.nextSibling;
            }
            menuItem.classList.add("navbar__menu--relative")
            menuItem.parentElement.style.height = menuItem.offsetHeight + 46 + "px";
            menuItem.parentElement.style.position = "relative";
        }

    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    useEffect(() => {
        if (innerWidth > 1023) {
            const navBarItems = document.getElementsByClassName("navbar__item-0");
            if (navBarItems && navBarItems.length > 0) {
                for (let i = 0; i < navBarItems.length; i++) {
                    const navBarItem = navBarItems[i];
                    const navBarMenuLevel1 = navBarItem.parentElement;
                    const navBarMenuLevel2 = navBarItem.getElementsByClassName("navbar__menu-1");
                    const orgNavBarMenuHeight = navBarMenuLevel1.offsetHeight;
                    navBarItem.addEventListener("mouseover", () => {
                        if (innerWidth > 1023) {
                            if (navBarMenuLevel2 && navBarMenuLevel2[0]) {
                                if (navBarMenuLevel2[0].offsetHeight >= navBarMenuLevel1.offsetHeight) {
                                    navBarMenuLevel1.style.height = navBarMenuLevel2[0].offsetHeight + "px";
                                } else {
                                    navBarMenuLevel1.style.height = orgNavBarMenuHeight + "px";
                                    navBarMenuLevel2[0].style.height = orgNavBarMenuHeight + "px";
                                }
                            } else {
                                navBarMenuLevel1.style.height = orgNavBarMenuHeight + "px";
                            }
                        }
                    });
                    navBarMenuLevel1.addEventListener("mouseleave", () => {
                        if (innerWidth > 1023) {
                            navBarMenuLevel1.style.height = "fit-content";
                        }
                    });
                }
            }
        }
    })

    return (
        <Fragment>
            {!contentLink ? (
                links.length > 0 &&
                <a
                    className="navbar__link--block navbar__icon--menu navbar__icon"
                    onClick={toggleMenu}
                    rel="nofollow"
                    href="#"
                    title={translate('general.menu') || 'menu'}
                >
                </a>
            ) : (
                <Fragment>
                    {contentLink.url
                        ?
                        <a
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                } ${additionClass || ''}`}
                            href={contentLink.url}
                            dangerouslySetInnerHTML={{ __html: contentLink.name }}
                        ></a>
                        :
                        <p
                            className={`navbar__link ${selectedClass} ${hasChildrenClass || ''
                                } ${additionClass || ''}`}
                            dangerouslySetInnerHTML={{ __html: contentLink.name }}
                        ></p>
                    }

                    {links.length > 0 && innerWidth < 1024 && (
                        <i
                            className={`navbar__icon navbar__icon--caret-right ${contentLink ? "navbar__icon--extraPadding" : ""}`}
                            onClick={contentLink.level === 1 ? toggleMenuLevelThree : toggleMenu}
                        ></i>
                    )}
                    {contentLink !== null && contentLink.level === 0 &&
                        <Fragment>
                            <span className='navbar__menu--space'></span>
                        </Fragment>
                    }
                </Fragment>
            )}

            {links.length > 0 && (
                <div className={`navbar__menu navbar__menu-${contentLink?.level}`} ref={menuRef}>
                    {contentLink !== null && contentLink.level === 0 &&
                        <Fragment>
                            <span className='navbar__menu--arrow'></span>
                        </Fragment>
                    }
                    <div className={`${contentLink && contentLink.level === 1 ? "navbar__menu-header-hide" : "navbar__menu-header"} `}>
                        {!contentLink ? (
                            <Fragment>
                                <span
                                    className="navbar__title"
                                >{translate('general.menu') || 'menu'}</span>
                                <span
                                    className="navbar__icon navbar__icon--close"
                                    onClick={toggleMenu}
                                ></span>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <a
                                    className="navbar__title"
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                    href={contentLink.url}
                                ></a>
                            </Fragment>
                        )}
                    </div>
                    {contentLink && contentLink.level === 0 && (
                        <div className="navbar__back" onClick={toggleMenu}>
                            <Fragment>
                                <span className='navbar__back--arrow'></span>
                                <span
                                    className="navbar__back--text"
                                >
                                    {translate('general.back') || 'Tillbaka'}
                                </span>
                            </Fragment>
                        </div>
                    )}
                    <ul className="navbar__menu-links">
                        {links.length > 0 &&
                            links.map(
                                (link, index) =>
                                    hasNameOrChildren(link) && (
                                        <li
                                            className={`navbar__item navbar__item-${contentLink === null ? "none" : contentLink.level} ${link && link.url ? "" : "default-cursor"}`}
                                            key={index}
                                        >
                                            <NavigationItem
                                                links={link.links}
                                                contentLink={link}
                                            />
                                        </li>
                                    )
                            )}
                    </ul>
                </div>
            )}
        </Fragment>
    );
};

export default NavigationItem;
